// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".post-image,.post-image img{position:relative}.post-image img{display:block;width:auto;height:auto;max-width:100%;margin:0 auto}.post-image img.is-logo{max-width:30rem;height:auto;margin-left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
